import Modal from "../modal";
import '@splidejs/react-splide/css';
import Details3D from "./reactComponent/details3D";

class ModalDetails extends Modal {
    constructor(objects = [], close) {

        super(null, close)

        
        this.objects = objects;

    }

    getBody() {
        return <Details3D objects={this.objects} close={this.getClose()}/>
    }
}

export default ModalDetails